/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import {PublicMessenger} from './../components/front/notifications/PublicMessenger.js';
// import {PublicMessagePopup} from './../components/front/notifications/PublicMessagePopup.js';
import {SocketCommandJavascript} from './../components/shared/notifications/SocketCommandJavascript.js';

import Echo from "laravel-echo";

if (process.env.MIX_ENABLE_SOCKET_SYSTEM === 'true') {
//Setup Client socket listener
// window.ClientEcho = new Echo({
// 	broadcaster: 'socket.io',
// 	host: window.location.hostname + ':6001'
// });
	try {
		//Setup Client and Core socket listener

		window.ClientEcho = new Echo({
			broadcaster: 'socket.io',
			host: window.location.hostname + ':6001'
		});

		window.CoreEcho = new Echo({
			broadcaster: 'socket.io',
			host: window.location.hostname + ':6008'
		});

	}
	catch (e) {
		// window.CoreEcho = null;
		// window.ClientEcho = null;
		console.error('window.CoreEcho & window.ClientEcho is null');
		console.error('e',e)
	}
}

let token = document.head.querySelector('meta[name="csrf-token"]');
if (token) {
	window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
}
else {
	console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}

/**********************************************************************/
//Sockets and Notifications with Global Scope
if (window.CoreEcho !== null) {
	if (process.env.MIX_ENABLE_CHAT_SYSTEM === 'true') {
		window.MessageSystem = new PublicMessenger({
			channel: process.env.MIX_CHAT_SYSTEM_CHANNEL,
			new_message_event: process.env.MIX_CHAT_SYSTEM_NEW_MESSAGE,
			update_queue_pos: process.env.MIX_CHAT_SYSTEM_UPDATE_QUEUE_POS,
			update_me_timeout: process.env.MIX_CHAT_SYSTEM_UPDATE_ME_CALL_TIMEOUT,
			user_is_typing: process.env.MIX_CHAT_SYSTEM_USER_IS_TYPING,
			close_issue: process.env.MIX_CHAT_SYSTEM_CLOSE_ISSUE,
			contact_us_url: process.env.MIX_CONTACT_US_URL,
			action: '/notifications/chat_system',
			local_storage_item: 'est_chat_system',
			request_data: '/notifications/chat_system/data'
		});
	}
	/**** Importing stuff for the build :) *******/
// console.warn('process.env',process.env);
	new SocketCommandJavascript({
		channel: process.env.MIX_JAVASCRIPT_COMMAND_CHANNEL,
		event: process.env.MIX_JAVASCRIPT_COMMAND_CHANNEL
	});

	// new PublicMessagePopup({
	// 	channel: process.env.MIX_PUBLIC_USER_MESSAGE_CHANNEL,
	// 	event: process.env.MIX_USER_MESSAGE_EVENT
	// });
}
/**********************************************************************/


// WEBPACK FOOTER //
// ./resources/assets/js/config/echoServer.js